import { CarWheelPosition, CarWheelPositions, CarWheelSetType, CarWheelSetTypes } from 'noddi-types';

export const getWheelSetTypeEmoji = (type: CarWheelSetType) => {
  switch (type.value) {
    case CarWheelSetTypes.Summer:
      return '☀️';
    case CarWheelSetTypes.Winter:
      return '❄️';
    case CarWheelSetTypes.AllSeason:
      return '🌎';
    default:
      return '❓';
  }
};

export const getWheelSetTypeTranslation = ({
  type,
  withEmoji = false
}: {
  type: CarWheelSetType;
  withEmoji?: boolean;
}) => {
  const emoji = getWheelSetTypeEmoji(type);
  switch (type.value) {
    case CarWheelSetTypes.Summer:
      return withEmoji ? `${emoji} Summer` : 'Summer';
    case CarWheelSetTypes.Winter:
      return withEmoji ? `${emoji} Winter` : 'Winter';
    case CarWheelSetTypes.AllSeason:
      return withEmoji ? `${emoji} All Season` : 'All Season';
    default:
      return withEmoji ? '❓ Unknown' : 'Unknown';
  }
};

export const getWheelSetTypeTranslationFromValue = ({
  value,
  withEmoji = false
}: {
  value: CarWheelSetType['value'];
  withEmoji?: boolean;
}) => {
  switch (value) {
    case CarWheelSetTypes.Summer:
      return withEmoji ? '☀️ Summer' : 'Summer';
    case CarWheelSetTypes.Winter:
      return withEmoji ? '❄️ Winter' : 'Winter';
    case CarWheelSetTypes.AllSeason:
      return withEmoji ? '🌎 All Season' : 'All Season';
    default:
      return withEmoji ? '❓ Unknown' : 'Unknown';
  }
};

export const getWheelPositionTranslation = (position: CarWheelPosition) => {
  switch (position.label) {
    case CarWheelPositions['Front left']:
      return 'Front left';
    case CarWheelPositions['Front right']:
      return 'Front right';
    case CarWheelPositions['Rear left']:
      return 'Rear left';
    case CarWheelPositions['Rear right']:
      return 'Rear right';
    default:
      return 'Unknown';
  }
};
